import { noAuthRoute } from '@/router/guards/auth'
import AcessoriesInstallation from '@/views/forms/AcessoriesInstallation.vue'

export default {
  path: '/formulario-instalacao-acessorios',
  name: 'form-acessories-installation',
  component: AcessoriesInstallation,
  meta: {
    noAuth: true
  },

  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()

    if (canEnter) {
      return next(true)
    }

    next('/main')
  }
}
